// import React from 'react';
// import { Viewer, Worker } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';

// import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';


// // Core viewer
// // import { Viewer } from '@react-pdf-viewer/core';

// // // // Plugins
// // import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// // // // Import styles
// // import '@react-pdf-viewer/core/lib/styles/index.css';
// // import '@react-pdf-viewer/default-layout/lib/styles/index.css';

// function CandResume({ resume }) {
//     resume = '/resume/static-resume.pdf'
//   // Create new plugin instance
//   // const defaultLayoutPluginInstance = defaultLayoutPlugin();
//   console.log('resume = ', resume);
//   const docs = [
//     { uri: resume}
//   ];
//   return resume != null ? (
//     <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
//       <div
//         style={{
//           border: '1px solid rgba(0, 0, 0, 0.3)',
//           height: '750px',
//         }}
//       >
//         <Viewer fileUrl={resume} />
//       </div>
//     </Worker>
//     // <DocViewer
//     //   documents={[{ url: resume }]}
//     //   pluginRenderers={DocViewerRenderers}
//     // />
//     // <DocViewer
//     //     pluginRenderers={DocViewerRenderers}
//     //     documents={docs}
//     //     config={{
//     //       header: {
//     //         disableHeader: false,
//     //         disableFileName: false,
//     //         retainURLParams: false
//     //       }
//     //     }}
//     //     style={{ height: 500 }}
//     //   />

//     // <iframe src={resume} />

//   ) : (
//     // <Viewer
//     //   fileUrl={resume}
//     //   plugins={[
//     //     // Register plugins
//     //     defaultLayoutPluginInstance,
//     //   ]}
//     // />
//     'No resume found'
//   );
// }

// export default CandResume;


// import React from 'react';
// import { Viewer, Worker } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';

// import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';

// // Core viewer
// // import { Viewer } from '@react-pdf-viewer/core';

// // // // Plugins
// // import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// // // // Import styles
// // import '@react-pdf-viewer/core/lib/styles/index.css';
// // import '@react-pdf-viewer/default-layout/lib/styles/index.css';

// function CandResume({ resume }) {
//   resume = '/resume/static-resume.pdf'

//   // const docs = [{
//   //   uri: "/resume/static-resume.pdf",
//   //   fileType: "pdf",
//   //   fileName: "static-resume.pdf"
//   // }]

//   // Create new plugin instance
//   // const defaultLayoutPluginInstance = defaultLayoutPlugin();
//   console.log('resume = ', resume);
//   return resume != null ? (
//     <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
//       <div
//         style={{
//           border: '1px solid rgba(0, 0, 0, 0.3)',
//           height: '750px',
//         }}
//       >
//         <Viewer fileUrl={resume} />
//       </div>
//     </Worker>
//     // <DocViewer
//     //   documents={docs}
//     //   pluginRenderers={DocViewerRenderers}
//     //   style={{ height: 1000 }}
//     // />
//   ) : (
//     // <Viewer
//     //   fileUrl={resume}
//     //   plugins={[
//     //     // Register plugins
//     //     defaultLayoutPluginInstance,
//     //   ]}
//     // />
//     'No resume found'
//   );
// }

// export default CandResume;

import React, { useState, useEffect } from 'react';
import axios from "axios";
import { selectCandidateInterview } from '../../../../../../../features/hiringstages/candidateInterviewSlice';
import { useGetInterviewCandDetailsQuery } from '../../../../../../../features/hiringstages/interviewApiSlice';
import { useSelector } from 'react-redux';
import { getPresignedUrl } from '../../../../../../../components/common/getPresignedUrl';

export default function CandResume() {

  const candId = useSelector(selectCandidateInterview);
  const {
    data: canddetails,
    isLoading,
    isSuccess,
  } = useGetInterviewCandDetailsQuery(candId, {
    refetchOnMountOrArgChange: true,
  }); 
  console.log(canddetails)
  const fileName = canddetails?.data.fileName
  console.log('resume = ', fileName);

  // resume = '/resume/static-resume.pdf'

  //PDFjs worker from an external cdn
  // const url =
  //   `https://cors-anywhere.herokuapp.com/${resume}`
  // pdfjs.GlobalWorkerOptions.workerSrc =
  //   `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  // const [numPages, setNumPages] = useState(null);
  // const [pageNumber, setPageNumber] = useState(1);

  // function onDocumentLoadSuccess({ numPages }) {
  //   setNumPages(numPages);
  //   setPageNumber(1);
  // }
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
 

   useEffect(() => {
     async function fetchPdf() {
       setLoading(true);
       const url = await getPresignedUrl(fileName);
       setPdfUrl(url);
       setLoading(false);
     }
 
     fetchPdf();
   }, [fileName]);
 
  return (
    <>
      {/* <div className="main">
        <Document
          file={url}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <Page pageNumber={pageNumber} />
        </Document>
      </div> */}
    <div style={{ marginTop: "20px", height: "500px" }}>
        {loading ? (
          <p>Loading PDF...</p>
        ) : pdfUrl ? (
          <iframe src={pdfUrl} width="100%" height="100%" style={{ border: "none" }} />
        ) : (
          <p style={{ color: "red", textAlign: "center", backgroundColor: "whitesmoke" }}>
            ❌ No file found
          </p>
        )}
      </div>
    </>
  );
}
